import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import Header from "../../layouts/Header";
import {
  Layout,
  Menu,
  List,
  Typography,
  Space,
  Modal,
  Button,
  Row,
  Col,
  Card,
} from "antd";
import {
  UnorderedListOutlined,
  FormOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  FileTextOutlined,
  EditOutlined,
  DeleteOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import AddIcon from "../../assets/icons/addicon.svg";
import formBuilder from "../../assets/icons/formBuilder.svg";
import editIcon from "../../assets/icons/editIcon.svg";
import "../Form_Builder_POC/FormBuilderPOC.css";
import {
  fetchFormList,
  fetchTemplateForms,
  deleteForm,
  fetchFormById,
} from "../../redux/actions/action";

const { Content, Sider } = Layout;
const { Title } = Typography;

const FormsPOC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const params = useParams();
  console.log("param", params.id);
  const ASCpocName = localStorage.getItem("ASCpocName");

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Setting-FormBuilder-List").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  // state start from here 👇
  const [tabChange, setTabChange] = useState("Templates");
  const [btnHover, setBtnHover] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All templates");
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [formToDelete, setFormToDelete] = useState(null);
  const [paginatedFormList, setPaginatedFormList] = useState([]);
  const [paginatedItems, setPaginatedItems] = useState(10);
  const [selectedFormId, setSelectedFormId] = useState("");
  const [formLading, setFormLoading] = useState(false);
  const [templateLading, setTemplateLoading] = useState(false);
  const [deleteLading, setDeleteLoading] = useState(false);

  const { formList, templateForms } = useSelector((state) => state.user);

  const templates = [
    { id: 1, name: "Checklist", icon: <UnorderedListOutlined /> },
    { id: 2, name: "Hiring Worker", icon: <FormOutlined /> },
  ];

  const siderStyle = {
    background: "#fff",
    padding: "20px",
  };

  const menuStyle = {
    border: "none",
  };

  const contentStyle = {
    padding: "20px",
    minHeight: "100vh",
    background: "#fff",
    width: "100%",
    marginTop: "-10px",
  };

  const cardStyle = {
    width: "100%",
    height: "200px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  };

  const cardBodyStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
  };

  const iconStyle = {
    fontSize: "48px",
    color: "#1890ff",
  };

  const categories = [
    { key: "Risk and Assessment", label: "Risk and Assessment", count: 1 },
    {
      key: "Health and Safety Plan",
      label: "Health and Safety Plan",
      count: 1,
    },
  ];

  // function start from here 👇
  const handleSave = (data) => {
    // asc
  };

  const showDeleteModal = (form) => {
    setFormToDelete(form);
    setIsDeleteModalVisible(true);
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalVisible(false);
    setFormToDelete(null);
  };

  const handleDeleteConfirm = () => {
    setFormToDelete(null);
    setDeleteLoading(true);
    dispatch(deleteForm(selectedFormId)).then((res) => {
      if (res?.status === true) {
        fetchForms();
        setDeleteLoading(false);
        setIsDeleteModalVisible(false);
      }
    });
  };
  const fetchForms = async () => {
    setFormLoading(true);
    const res = await Promise.resolve(dispatch(fetchFormList()));
    setFormLoading(false);
  };

  const fetchTemplateFormList = async () => {
    setTemplateLoading(true);
    const res = await Promise.resolve(dispatch(fetchTemplateForms()));
    setTemplateLoading(false);
  };

  useEffect(() => {
    fetchForms();
    fetchTemplateFormList();
  }, []);

  useEffect(() => {
    if (
      formList &&
      formList.data &&
      Array.isArray(formList.data) &&
      paginatedItems >= 10
    ) {
      const list = formList.data.slice(paginatedItems - 10, paginatedItems);
      setPaginatedFormList(list);
    }
  }, [formList, paginatedItems]);

  return (
    <>
      <section className="px-5" style={{ overflow: "hidden" }}>
        <Header
          // setQuery={setQuerystring}
          leftComponent={
            <div className="d-flex align-items-baseline flex-wrap gap-4">
              <div
                className="settingText"
                onClick={() => {
                  history.push("/settings");
                }}
              >
                {/* Settings */}
                {t("Settings")}
              </div>
              <div
                className="pt-2 d-flex pe-3"
                style={{ background: "#FFFFFF", borderRadius: "10px" }}
              >
                <p className="pt-1 ps-4 myplanTxt">
                  {/* Forms */}
                  {t("Forms")}
                </p>
                {/* <p className="pt-1 projectID ps-5"> &nbsp;{invoiceId} </p> */}
              </div>
            </div>
          }
        />

        <div className="d-flex pt-2 justify-content-end">
          <button
            className="mb-0 addNewForm ascButton"
            onMouseEnter={() => setBtnHover(true)}
            onMouseLeave={() => setBtnHover(false)}
            onClick={() => {
              history.push({
                pathname: "/form-builder",
                state: { formPopUp: true },
              });
              localStorage.removeItem("ASCformPOC");
            }}
          >
            <img src={btnHover ? AddIcon : formBuilder} alt="" />
            {/* Add New */}
            {t("Add New ")}
          </button>
        </div>

        {/* Templates div start */}
        <div className="pt-3 row">
          <div
            className={`col-6 col-lg-2 pt-4 text-center pointer ${
              tabChange === "Templates"
                ? "pocDivHeadBox-highlighter"
                : "pocDivHeadBox-non-highlighter"
            }`}
            onClick={() => setTabChange("Templates")}
          >
            <p>
              {/* Templates */}
              {t("Templates ")}
            </p>

            <hr
              className={
                tabChange === "Templates"
                  ? "planHorizontalBarPro"
                  : "planHorizontalBar"
              }
            />
          </div>
          {/* Templates div end */}

          {/* Forms div start */}
          <div
            className={`col-6 col-lg-2 pt-4 text-center pointer ${
              tabChange === "Forms"
                ? "pocDivHeadBox-highlighter"
                : "pocDivHeadBox-non-highlighter"
            }`}
            onClick={() => setTabChange("Forms")}
          >
            <p>
              {/* Forms */}
              {t("Forms")}
            </p>

            <hr
              className={
                tabChange === "Forms"
                  ? "planHorizontalBarPro"
                  : "planHorizontalBar"
              }
            />
          </div>
          {/* Forms div end */}
        </div>

        <div className="pocUnderDiv pt-4  row">
          {tabChange === "Templates" && (
            <div
              style={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                gap: "15px",
              }}
            >
              <Sider width={250} style={siderStyle}>
                <h2
                  style={{
                    padding: "16px",
                    fontWeight: "400",
                    color: "#A5A5A5",
                    fontSize: "13px",
                    paddingBottom: "5px",
                    borderBottom: "1px solid #A5A5A5",
                  }}
                >
                  {/* Templates */}
                  {t("Templates ")}
                </h2>
                <div mode="inline" style={menuStyle}>
                  <div
                    key="all"
                    style={{
                      fontWeight: "500",
                      marginBottom: "10px",
                      fontSize: 14,
                    }}
                  >
                    {/* {`   All templates (${templateForms?.data?.length})`} */}
                    {`  ${t("All Templates ")} (${templateForms?.data?.length})`}
                  </div>
                  {templateForms?.data?.map((template) => (
                    <div
                      key={template.id}
                      style={{
                        marginBottom: "10px",
                        fontSize: 14,
                        color: "#454545",
                      }}
                    >
                      {template?.formName}
                    </div>
                  ))}
                </div>
              </Sider>
              <div style={contentStyle}>
                <Row gutter={[16, 16]}>
                  {templateForms?.data?.map((template) => {
                    return (
                      <Col span={12} key={template.id}>
                        <Card style={cardStyle} bodyStyle={cardBodyStyle}>
                          {/* <div style={iconStyle}>{template.icon}</div> */}
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "18px",
                              fontWeight: "bold",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              history.push({
                                pathname: "/form-builder",
                                state: { formPopUp: false },
                              });
                              dispatch(fetchFormById(template.formid));
                            }}
                          >
                            {template?.formName}
                          </div>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </div>
          )}

          {tabChange === "Forms" && (
            <div
              style={{
                width: "100%",
                backgroundColor: "#fff",
                paddingBottom: "9rem",
              }}
            >
              <div style={{ padding: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "16px",
                    borderBottom: "1px solid #A5A5A5",
                  }}
                >
                  <Title
                    level={5}
                    style={{
                      fontWeight: "400",
                      color: "#A5A5A5",
                      fontSize: "13px",
                    }}
                  >
                    {/* All forms */}
                    {t("All Forms ")}
                  </Title>
                  {formLading ? (
                    <LoadingOutlined />
                  ) : (
                    <Space>
                      <span style={{ color: "#a5a5a5", fontSize: "12px" }}>{`${
                        paginatedItems - 9
                      }-${
                        paginatedItems > formList?.data?.length
                          ? formList?.data?.length
                          : paginatedItems
                      } of ${formList?.data?.length}`}</span>
                      <LeftOutlined
                        style={{
                          cursor: "pointer",
                          color: "#a5a5a5",
                          height: "12px",
                          width: "12px",
                        }}
                        onClick={() => {
                          if (paginatedItems > 10)
                            setPaginatedItems((prev) => prev - 10);
                        }}
                      />
                      <RightOutlined
                        style={{
                          cursor: "pointer",
                          color: "#a5a5a5",
                          height: "12px",
                          width: "12px",
                        }}
                        onClick={() => {
                          if (paginatedItems < formList?.data?.length)
                            setPaginatedItems((prev) => prev + 10);
                        }}
                      />
                    </Space>
                  )}
                </div>
                {formLading ? (
                  <LoadingOutlined />
                ) : (
                  <List
                    style={{ minHeight: "fit-content" }}
                    dataSource={paginatedFormList?.map((form) => {
                      return { name: form?.formName, ...form };
                    })}
                    // dataSource={forms}
                    renderItem={(item) => (
                      <List.Item
                        actions={[
                          <EditOutlined
                            key="edit"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              history.push({
                                pathname: "/form-builder",
                                state: { formPopUp: false },
                              });
                              localStorage.setItem("formCondition", false);
                              dispatch(fetchFormById(item?.formId));
                            }}
                          />,
                          <DeleteOutlined
                            key="delete"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelectedFormId(item?.formId);
                              showDeleteModal(item);
                            }}
                          />,
                        ]}
                      >
                        <List.Item.Meta
                          avatar={<FileTextOutlined />}
                          title={item.name}
                        />
                      </List.Item>
                    )}
                  />
                )}
              </div>
            </div>
          )}
          {/* {tabChange === "Forms" && <SubscriptionInvoices />} */}
        </div>
      </section>
      <Modal
        centered
        visible={isDeleteModalVisible}
        footer={false}
        closeIcon={false}
        width={470}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
            width: "80%",
            margin: "0 auto",
            height: "213px",
          }}
        >
          <p style={{ textAlign: "center" }}>
            {/* This form will be deleted and will no longer be available. */}
            {t(
              " This form will be deleted and will no longer be available. Do you want to proceed?",
            )}
          </p>
          {/* <p>Do you want to proceed?</p> */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "80px",
              marginTop: "40px",
            }}
          >
            <Button
              key="cancel"
              onClick={handleDeleteCancel}
              style={{ width: "7rem" }}
            >
              {/* No */}
              {t("No ")}
            </Button>

            <Button
              key="submit"
              type="primary"
              style={{ backgroundColor: "#f76767", width: "7rem" }}
              danger
              loading={deleteLading}
              onClick={handleDeleteConfirm}
            >
              {/* Delete */}
              {t("Delete")}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FormsPOC;
